import { Type } from '@angular/core';

import { AnyDynamicElement } from '../models/dynamic/dynamic-element.model';
import { AccordionComponent } from '../../accordion/accordion.component';
import { AnchorComponent } from '../../anchor/anchor.component';
import { ArticleInfoBarComponent } from '../../article-info-bar/article-info-bar.component';
import { AuthorComponent } from '../../author/author.component';
import { AuthorsComponent } from '../../authors/authors.component';
import { BannerComponent } from '../../banner/banner.component';
import { BreadcrumbComponent } from '../../breadcrumb/breadcrumb.component';
import { ButtonGroupComponent } from '../../button/button-group/button-group.component';
import { CardCatalogueComponent } from '../../card/card-collection/card-catalogue/card-catalogue.component';
import { CardFlipGridComponent } from '../../card/card-collection/card-flip-grid/card-flip-grid.component';
import { CardGridComponent } from '../../card/card-collection/card-grid/card-grid.component';
import { CardSliderComponent } from '../../card/card-collection/card-slider/card-slider.component';
import { ChecklistComponent } from '../../checklist/checklist.component';
import { FeatureComponent } from '../../feature/feature.component';
import { FeaturedResourcesComponent } from '../../featured-resources/featured-resources.component';
import { FeatureListComponent } from '../../feature-list/feature-list.component';
import { FormButtonComponent } from '../../form/form-button/form-button.component';
import { FormCheckboxComponent } from '../../form/form-checkbox/form-checkbox.component';
import { FormConsentCheckboxComponent } from '../../form/form-consent-checkbox/form-consent-checkbox.component';
import { FormFeatureEmbeddedComponent } from '../../form/form-feature/form-feature-embedded/form-feature-embedded.component';
import { FormHiddenComponent } from '../../form/form-hidden/form-hidden.component';
import { FormInputComponent } from '../../form/form-input/form-input.component';
import { FormRadioComponent } from '../../form/form-radio/form-radio.component';
import { FormSelectComponent } from '../../form/form-select/form-select.component';
import { FormTextareaComponent } from '../../form/form-textarea/form-textarea.component';
import { HeaderComponent } from '../../header/header.component';
import { HeroSliderComponent } from '../../hero-old/hero-slider/hero-slider.component';
import { HeroGradientBackgroundComponent } from '../../hero/hero-gradient-background/hero-gradient-background.component';
import { HeroImageBackgroundComponent } from '../../hero/hero-image-background/hero-image-background.component';
import { HeroV3Component } from '../../hero-v3/hero-v3.component';
import { HighlightedItemComponent } from '../../highlighted-item/highlighted-item.component';
import { LeadooInpageBotComponent } from '../../leadoo-inpage-bot/leadoo-inpage-bot.component';
import { MediaCollageComponent } from '../../media/media-collection/media-collage/media-collage.component';
import { MediaSliderComponent } from '../../media/media-collection/media-slider/media-slider.component';
import { MediaComponent } from '../../media/media-single/media.component';
import { PredefinedScriptComponent } from '../../predefined-script/predefined-script.component';
import { ProductComparerComponent } from '../../product-comparer/product-comparer.component';
import { ProductFeatureExplorerComponent } from '../../product-feature-explorer/product-feature-explorer.component';
import { ProductHeaderComponent } from '../../product-header/product-header.component';
import { ProductHeaderV2Component } from '../../product-header-v2/product-header-v2.component';
import { QuoteComponent } from '../../quote/quote.component';
import { SearchPageComponent } from '../../search-page/search-page.component';
import { SectionComponent } from '../../section/section.component';
import { SpacerComponent } from '../../spacer/spacer.component';
import { TableGroupComponent } from '../../tables';
import { TabGroupDynamicComponent } from '../../tabs/tab-group/tab-group-dynamic.component';
import { TabGroupDynamicV2Component } from '../../tabs/tab-group-v2/tab-group-dynamic-v2.component';
import { TextHighlightComponent } from '../../text-highlight/text-highlight.component';
import { TextWithIntroComponent } from '../../text-with-intro/text-with-intro.component';
import { TextBodyComponent } from '../../text/text-body.component';
export abstract class DynamicElements {
    static components: { [key: string]: Type<AnyDynamicElement> }[] = [
        { 'accordion': AccordionComponent },
        { 'anchor': AnchorComponent },
        { 'article-info-bar': ArticleInfoBarComponent },
        { 'author': AuthorComponent },
        { 'authors': AuthorsComponent },
        { 'banner': BannerComponent },
        { 'breadcrumb': BreadcrumbComponent },
        { 'button-group': ButtonGroupComponent },
        { 'card-grid': CardGridComponent },
        { 'card-flip-grid': CardFlipGridComponent },
        { 'card-overview': CardCatalogueComponent },
        { 'card-slider': CardSliderComponent },
        { 'checklist': ChecklistComponent },
        { 'feature': FeatureComponent },
        { 'featured-resources': FeaturedResourcesComponent },
        { 'feature-list': FeatureListComponent },
        { 'form-button': FormButtonComponent },
        { 'form-checkbox': FormCheckboxComponent },
        { 'form-consent-checkbox': FormConsentCheckboxComponent },
        { 'form-feature-embedded': FormFeatureEmbeddedComponent },
        { 'form-hidden': FormHiddenComponent },
        { 'form-input': FormInputComponent },
        { 'form-radio': FormRadioComponent },
        { 'form-select': FormSelectComponent },
        { 'form-textarea': FormTextareaComponent },
        { 'google-search-component': SearchPageComponent },
        { 'grid': CardGridComponent },
        { 'hero-gradient-background': HeroGradientBackgroundComponent },
        { 'hero-image-background': HeroImageBackgroundComponent },
        { 'hero-v3': HeroV3Component },
        { 'hero': HeroSliderComponent },
        { 'highlighted-item': HighlightedItemComponent },
        { 'leadoo-inpage-bot': LeadooInpageBotComponent },
        { 'media-collage': MediaCollageComponent },
        { 'media-slider': MediaSliderComponent },
        { 'media': MediaComponent },
        { 'predefined-script': PredefinedScriptComponent },
        { 'product-comparer': ProductComparerComponent },
        { 'product-feature-explorer': ProductFeatureExplorerComponent },
        { 'product-header': ProductHeaderComponent },
        { 'product-header-v2': ProductHeaderV2Component },
        { 'quote': QuoteComponent },
        { 'section': SectionComponent },
        { 'spacer': SpacerComponent },
        { 'table-set': TableGroupComponent },
        { 'tabs': TabGroupDynamicComponent },
        { 'tabs-v2': TabGroupDynamicV2Component },
        { 'text-header': HeaderComponent },
        { 'text-highlight': TextHighlightComponent },
        { 'text-with-intro': TextWithIntroComponent },
        { 'text': TextBodyComponent },
    ];
}
